import { useBlackBaudAuthFlow, buildNangoConfig, PROVIDER_BB_CRM } from "./blackbaud-auth-flow";

export const useBlackBaudCrmAuthFlow = () => {
  return useBlackBaudAuthFlow(buildNangoConfig(PROVIDER_BB_CRM));
};

export default useBlackBaudCrmAuthFlow;